import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import Wrapper from '../components/wrapper'
import AppBarInner from '../components/app-bar/AppBarInner'
import AppStepper from '../components/app-stepper'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'
import MyTargetChanelForm from '../components/app-form/MyTargetChanelForm'
import { MyTargetIcon, BackIcon } from '../components/app-icon/Icons'
import CustomizeAll from '../components/сustomize-all/'

const styles = theme => ({
  page: {
    maxWidth: 1072,
    display: 'flex',
    margin: '0 auto',
  },
  sidebar: {},
  header: {},
  navigation: {
    display: 'flex',
    margin: '10px 0 0 0',
    padding: '0 24px',
  },
  content: {
    maxWidth: 630,
    width: '100%',
    marginTop: 32,
  },
  title: {
    position: 'relative',
    padding: '27px 24px 0 14px',
  },
  description: {
    padding: '0 85px 85px 60px',
  },
  chanelIcon: {
    position: 'absolute',
    borderRadius: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: 24,
    right: 24,
    width: 96,
    height: 96,
    border: 'solid 1px #0000001a',
    backgroundColor: '#ffffff',
  },
  back: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    marginRight: 5,
  },
})

function getSteps() {
  return [
    `Аккаунт \nподтвержден`,
    'Сайт \nдобавлен',
    'Google Analytics \nнастроен',
    'Добавьте каналы \nдля сбора данных \nо расходах',
    'Подключение CRM\nсистемы',
    'Подключение\nколлтрекинга',
  ]
}

class MyTargetSetting extends Component {
  state = {
    activeStep: 3,
    dataSource: window.state.dataSource,
    isFetching: false,
  }

  redirect = (url, status) => {
    if (status === 'ok') {
      location.href = url
    }
  }

  handleSubmit = values => {
    this.setState({
      isFetching: true,
    })

    const url = this.state.dataSource.updateUrl

    const json = response => {
      return response.json()
    }

    const status = response => {
      if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response)
      } else {
        return Promise.reject(new Error(response.statusText))
      }
    }

    fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(values),
    })
      .then(status)
      .then(json)
      .then(({ redirectUrl, status }) => {
        this.timerId = setTimeout(
          () => this.redirect(redirectUrl, status),
          1000
        )
      })
      .catch(function(error) {
        console.log('Request failed', error)
      })
  }

  render() {
    const { classes } = this.props
    const { dataSource } = this.state
    const steps = getSteps()

    return (
      <main className={classes.page}>
        <CustomizeAll />

        <aside className={classes.sidebar}>
          <header className={classes.header}>
            <AppBarInner />
          </header>
          <nav className={classes.navigation}>
            <LeftNavigationDashboard />
            <AppStepper activeStep={this.state.activeStep} steps={steps} />
          </nav>
        </aside>

        <article className={classes.content}>
          <Wrapper shadow={4}>
            <header className={classes.title}>
              <Typography
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: 10,
                  fontWeight: 'normal',
                  fontStyle: 'normal',
                  fontStretch: 'normal',
                  lineHeight: 1.6,
                  letterSpacing: 0.8,
                  color: '#000000',
                }}
              >
                <a href="/wizard/sources/settings" className={classes.back}>
                  <BackIcon width={24} height={24} stroke={'#000000'} />
                </a>
                Подключение рекламных площадок
              </Typography>

              <div className={classes.chanelIcon}>
                <MyTargetIcon width={53} height={53} />
              </div>
            </header>
            <section className={classes.description}>
              <Typography variant="h3" style={{ marginBottom: 20 }}>
                {this.state.dataSource.status === 'active'
                  ? 'MyTarget'
                  : 'Подключаем MyTarget'}
              </Typography>

              <MyTargetChanelForm
                onSubmit={this.handleSubmit}
                isFetching={this.state.isFetching}
                dataSource={dataSource}
                initialValues={
                  dataSource && {
                    vat: dataSource.vat || '0',
                  }
                }
              />
            </section>
          </Wrapper>
        </article>
      </main>
    )
  }
}

export default withStyles(styles)(MyTargetSetting)
